import API from '../../clients/api'

const fetchCourseByIdWithTopicLessons = async id => {
  const route = `courses/${id}?embed=groups.topics.levels.videos,groups.topics.levels.quizzes,presenter,track.vendor,difficulties,files,allRatings`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(error.response.data))
}

const fetchNewCourses = async number => {
  const route = `courses/tagged/new?number=${number}&embed=presenter,track.vendor,difficulties`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(error.response.data))
}

const fetchTrendingCourses = async number => {
  const route = `courses/popular?metric=course-views&number=${number}&embed=presenter,track.vendor,difficulties`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(error.response.data))
}

const fetchPopularCourses = async number => {
  const route = `courses/popular?metric=active&number=${number}&embed=presenter,track.vendor,difficulties`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(error.response.data))
}

const fetchFeaturedCourses = async () => {
  const route = `courses/featured?embed=presenter,track.vendor,difficulties`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(error.response.data))
}

const postCourseFeedback = async formData => {
  const {
    courseId: reviewable_id,
    userId: author_id,
    instructorRating: customer_service_rating,
    contentRating: quality_rating,
    overallRating: rating,
    comments: body,
  } = formData

  const postBody = {
    reviewable_id,
    reviewable_type: 'course',
    author_id,
    customer_service_rating,
    quality_rating,
    rating,
    body,
  }
  const route = `ratings`
  return API.post(route, postBody)
    .then(response => response.data)
    .catch(error => error.response.data)
}

const fetchAllCourses = async number => {
  const route = `courses?number=${number}&embed=track.vendor,presenter`
  return API.get(route)
    .then(response => response.data.data)
    .catch(error => error.response.data)
}

export {
  fetchNewCourses,
  fetchTrendingCourses,
  fetchPopularCourses,
  fetchFeaturedCourses,
  fetchCourseByIdWithTopicLessons,
  postCourseFeedback,
  fetchAllCourses,
}
